module.exports = __webpack_public_path__ + "img/add-s-2.011151aa.png";